<template>
    <Dialog :dialog="dlg">
        <template v-slot:toolbar-left>
            
            <ToolbarField label="Status">
                <StatusChip :model="model"></StatusChip>
            </ToolbarField>



        </template>
        <template v-slot:toolbar-right>
            <ActionMenu>
                <ActionButton comboContextButton icon='menu-vertical'></ActionButton>
                <template v-slot:dropdown>
                    <slot name="contextMenu">
                        <ActionMenuItem action="workorder.pdf" icon="pdf" @click="() => onPdf(model.id)">Open PDF</ActionMenuItem>
                        <ActionMenuItem :disabled="!model.id" action="workorder_send.open" icon="email" @click="() => onEmail(model.id)">Email werkbon</ActionMenuItem>
                    </slot>
                </template>
            </ActionMenu>

            <StatusButtons class="mr-4" 
                :disable-all="model.isNew||!model.canModify"
                :can-planned="canPlanned()"
                :can-executing="canExecuting()"
                :can-executed="canExecuted()"
                :can-finished="canFinished()"
                :can-canceled="canCanceled()"

                @onPlanned="onStatusPlanned"
                @onExecuting="onStatusExecuting"
                @onExecuted="onStatusExecuted"
                @onFinished="onStatusFinished"
                @onCanceled="onStatusCanceled"
            >
            </StatusButtons>

            <div v-if="false">
            <ActionButton :model="model" v-if="!model.isArchived" ml action="workorder.archive" icon="archive" @click="onArchive">Status Gereed</ActionButton>
            <ActionButton :model="model" v-else ml action="salesorder.unarchive" icon="unarchive" @click="onUnArchive">Maak actueel</ActionButton>            
            <!-- ActionButton :model="model" icon="salesinvoice" ml main @click='()=>onStartCreateInvoice()'>Maak factuur</ActionButton -->
             </div>
        </template>

        <template v-slot:toolbar-menu>
                
        </template>        

        <template v-slot:tabs-left>
            <v-tabs dense v-model="dlg.tab">        
                <v-tab>Gegevens</v-tab>                
                <v-tab :disabled="model.isLoading||model.isNew">Materialen</v-tab>
                <v-tab :disabled="model.isLoading||model.isNew">Afspraken</v-tab>
                <v-tab :disabled="model.isLoading||model.isNew">Uren</v-tab>
                <v-tab :disabled="model.isLoading||model.isNew">Bijlagen ({{ (model.attachments||[]).length }})</v-tab>
                <v-tab :disabled="model.isLoading||model.isNew">Facturen ({{ (model.invoices||[]).length }})</v-tab>
            </v-tabs>
        </template>        

        <v-tabs-items class="workorder-tabs mt-0" v-model="dlg.tab">                
            <v-tab-item class="workorder-header" transition="none" reverse-transition="none">                        
                <v-form ref="formHeader" lazy-validation>
                    <TabHeader :model="model"></TabHeader>
                </v-form>
            </v-tab-item>
            <v-tab-item class="workorder-material" transition="none" reverse-transition="none">                        
                <TabMaterials :model="model"></TabMaterials>
            </v-tab-item>
            <v-tab-item class="workorder-appointments" transition="none" reverse-transition="none">                        
                <TabAppointments :model="model"></TabAppointments>
            </v-tab-item>
            <v-tab-item class="workorder-hours" transition="none" reverse-transition="none">                        
                <TabHours :model="model"></TabHours>
            </v-tab-item>
            <v-tab-item class="workorder-attachments" transition="none" reverse-transition="none">                        
                <TabAttachments :model="model"></TabAttachments>                
            </v-tab-item>
            <v-tab-item class="workorder-invoicing" transition="none" reverse-transition="none">                        
                <TabInvoicing :model="model"></TabInvoicing>                
            </v-tab-item>
        </v-tabs-items>

        <DialogModelCreateInvoice/>

    </Dialog>
</template>



<script setup>
    import useModel from '@/features/workorders/workorder/model/workorder'
    import { workorders as api } from '@app/api'
    
    import Dialog from '@shared/ui/dialogs/ActionDialogModal'
    import { ref, watch } from 'vue'
    import clsDialog from '@cls/clsDialog'
    import ToolbarField from '@shared/ui/dialogs/ToolbarField'
    import StatusChip from '@/features/workorders/workorder/controls/StatusChip'
    import StatusButtons from '@/features/workorders/workorder/controls/StatusButtons'
    
    import TabHeader from './TabHeader'
    import TabMaterials from './TabMaterials'
    import TabAppointments from './TabAppointments'
    import TabHours from './TabHours'
    import TabAttachments from './TabAttachments'
    import TabInvoicing from './TabInvoicing'
    import eventbus from '@app/eventbus'
    import noty from '@shared/lib/noty'
    import ActionButton from '@controls/buttons/ActionButton'
    import ActionMenu from '@controls/menu/ActionMenu.vue'
    import ActionMenuItem from '@controls/menu/ActionMenuItem.vue'
    import appDlg from '@app/dlg'
    import DialogModelCreateInvoice from '@/features/workorders/workorder/dialog/createinvoice/DialogModelCreateInvoice.vue'

    import Constants from '@app/consts'
    let st = Constants.workorder.status;

    const formHeader = ref(null); 

    let model = useModel();
    let dlg = ref(
        new clsDialog("workorder", "Werkbon", model, [formHeader], {
            setKeyOnOpen: true,
            showNote: true,
            showFlag: true,
            keepOpen: true
        } )).value;

    var canPlanned   = () => model.id_status==st.STATUS_EXECUTING;
    var canExecuting = () => model.id_status==st.STATUS_PLANNED;
    var canExecuted  = () => model.id_status==st.STATUS_EXECUTING || model.isFinished;
    var canFinished  = () => model.id_status==st.STATUS_EXECUTED && !model.isFinished;
    var canCanceled  = () => (!model.canceled_at) && (model.id_status==st.STATUS_CONCEPT || model.id_status==st.STATUS_PLANNED)&&!model.hasExecutedAppointment;

    async function onChangeStatus(fnMethod, confirmMsg, successMsg) {

        successMsg = successMsg || "De status van de geselecteerde werkbonnen is aangepast.";

        if (!await noty.tryConfirm(confirmMsg)) {
            return; 
        }
        await fnMethod(); 
        noty.snack.success(successMsg);
    }

    async function onStatusPlanned()   { onChangeStatus(async ()=>await model.toStatusPlanned(), "Alle afspraken in de werkbon worden verborgen voor medewerkers."); }
    async function onStatusExecuting() { onChangeStatus(async ()=>await model.toStatusExecuting(), "Alle afspraken in de werkbon worden zichtbaar voor medewerkers."); }
    async function onStatusExecuted()  { onChangeStatus(
        async ()=>await model.toStatusExecuted(), 
        model.isFinished ? "De werkbon gaat terug naar status 'Uitgevoerd'" :
        "Alle afspraken in de werkbon krijgen status 'Uitgevoerd'."); 
    }
    async function onStatusFinished()  { onChangeStatus(async ()=>await model.toStatusFinished(), "De werkbon wordt naar het archief verplaatst. Vanuit het archief kunt u de werkbon altijd terugvinden."); }
    async function onStatusCanceled()  { onChangeStatus(async ()=>await model.toStatusCanceled(), "De werkbon krijgt status 'Vervallen'. Nog niet uitgevoerde afspraken worden verwijderd."); }

    async function onPdf(id) {
        if (!id) {
            noty.alert("Sla de werkbon eerst op.");
            return;
        }   
        await eventbus.dialog.pdfviewer(async () => api.workorderPdf(id));        
    }
    async function onEmail(id) {
        appDlg.open('workorder_send', {id: id});
    }

</script>

